/**
 * Loading Messages Configuration (#748)
 *
 * Random, uplifting messages shown during loading states.
 * Universal pool drawn from running, cycling, trail, MTB, and gravel.
 *
 * Tone Guidelines:
 * - Kind, effort-respecting
 * - Gently playful
 * - Would work on a hoodie
 * - Applies to beginners AND veterans
 */

export const LOADING_MESSAGES = [
  // Universal / Running
  'Importing sunshine…',
  'Trying on shoes…',
  'Carb loading…',
  'Searching for clean socks…',
  'Locating race packet…',
  'Acquiring GPS signal…',
  'Overcoming inner demons…',
  'Building base fitness…',
  'Summoning run buddies…',
  'Mixing hydration bottles…',
  'Lacing up…',
  'Building momentum…',
  'Packing essentials…',
  'Mapping routes…',
  'Checking conditions…',
  'Warming up…',
  'Crafting super shoes…',
  'Summoning inner courage…',
  'Stretching it out…',
  'Pinning on bib…',
  'Gathering the group…',
  'Trusting the training…',
  'Greeting the morning…',

  // Cycling (Road)
  'Checking tire pressure…',
  'Spinning up drivetrain…',
  'Oiling chain…',
  'Syncing power meter…',
  'Packing nutrition…',
  'Settling into the saddle…',
  'Dialing in cadence…',
  'Calibrating watts…',
  'Clipping in…',
  'Rolling out…',
  'Savoring the tailwind…',
  'Mapping coffee stop…',

  // Trail / Ultra
  'Studying elevation…',
  'Adjusting headlamp…',
  'Packing extra layers…',
  'Reading terrain…',
  'Settling into the climb…',
  'Managing effort…',

  // Mountain Biking
  'Adjusting dropper post…',
  'Finding flow…',
  'Dialing in suspension…',
  'Checking the line…',
  'Earning descent…',

  // Gravel
  'Charting quiet roads…',
  'Packing frame bags…',
  'Dusting off routes…',
  'Taking the long way…',
];

export const SPINNER = ['|', '/', '—', '\\'];

/** Minimum time to show loading message (prevents screen flashes) */
export const MIN_DISPLAY_MS = 1000;
